import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    CheckBox,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffZonesEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formDescription, setFormDescription] = useState(null);
    const [formSendToOptime, setFormSendToOptime] = useState(false);
    const [formSendReadySms, setFormSendReadySms] = useState(false);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-zones-edit/save-data', {
            id: allProps['taroff-zones-id'],
            title: formTitle,
            description: formDescription,
            send_to_optime: formSendToOptime,
            send_ready_sms: formSendReadySms,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-zones-edit/form-data', {
            id: allProps['taroff-zones-id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormDescription(response.data.description);
            setFormSendToOptime(response.data.send_to_optime);
            setFormSendReadySms(response.data.send_ready_sms);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش محدوده</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شرح'}
                            value={formDescription}
                            onChange={setFormDescription}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox
                            label={'ارسال به آپتایم'}
                            value={formSendToOptime}
                            onChange={setFormSendToOptime}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox
                            label={'ارسال پیامک'}
                            value={formSendReadySms}
                            onChange={setFormSendReadySms}
                        />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
